import angular from 'angular';

export default function formatNumber() {
  return function link(int) {
    if (angular.isUndefined(int)) {
      return 0;
    }

    if (int % 1 === 0) {
      return int;
    }

    return int.toFixed(1);
  };
}
